import { css } from 'styled-components';

const secondaryTheme = {
    Wrapper: css`
        background-color: ${({ theme }) => theme.ColorBackgroundPrimary};
        border-radius: ${({ theme }) => theme.RadiusMedium};
    `,
    ProductCardTop: css`
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    `,
    ProductCardMid: css`
        padding: ${({ theme }) => `${theme.Spacing4} ${theme.Spacing12} 0`};
    `,
    ProductCardBottom: css`
        padding: ${({ theme }) => `0 ${theme.Spacing12} ${theme.Spacing12}`};
    `
};
export default secondaryTheme;
